import { buildModelManager } from "../builder.js";
const DefaultSessionSummaryV2Selection = {
  __typename: true,
  id: true,
  createdAt: true,
  generatedAt: true,
  sessionId: true,
  summaryText: { markdown: true, truncatedHTML: true },
  tokenCount: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "sessionSummaryV2";
const pluralModelApiIdentifier = "sessionSummaryV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultSessionSummaryV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSessionSummaryV2",
    operationReturnType: "CreateSessionSummaryV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      sessionSummaryV2: { required: false, type: "CreateSessionSummaryV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateSessionSummaryV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSessionSummaryV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "action",
    operationName: "updateSessionSummaryV2",
    operationReturnType: "UpdateSessionSummaryV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      sessionSummaryV2: { required: false, type: "UpdateSessionSummaryV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateSessionSummaryV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSessionSummaryV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "action",
    operationName: "deleteSessionSummaryV2",
    operationReturnType: "DeleteSessionSummaryV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSessionSummaryV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSessionSummaryV2",
    operationReturnType: "UpsertSessionSummaryV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      sessionSummaryV2: { required: false, type: "UpsertSessionSummaryV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSessionSummaryV2Result": { hasReturnType: false },
      "... on UpdateSessionSummaryV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertSessionSummaryV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSessionSummaryV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSessionSummaryV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "sessionSummaryV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SessionSummaryV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSessionSummaryV2Selection,
  operations
);
export {
  DefaultSessionSummaryV2Selection,
  SessionSummaryV2Manager
};
//# sourceMappingURL=SessionSummaryV2.js.map
